
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/panels/focusPanels/aiAssistantPanel/components/chat.scss.css.virtualfile';
        module.exports = {"container":"_container_x1lkf_1","messages":"_messages_x1lkf_6","input":"_input_x1lkf_12"};